import { useUser } from '@dfl/react-security';

/** `GET /auth/me` reports whether the account already has a primary second factor. */
const MFA_CONFIGURED_FIELD = 'mfaConfigured';

type MfaEnrollmentRequirement = {
  isRequired: boolean;
  isLoading: boolean;
  email?: string;
  reloadUser: () => void;
};

const useMfaEnrollmentRequired = (): MfaEnrollmentRequirement => {
  const { user, isLoading, isAuthenticated, loadUser } = useUser();
  const mfaConfigured = user?.[MFA_CONFIGURED_FIELD] as boolean | undefined;
  // Same condition UserControl uses to show the onboarding: the setup waits until it is done.
  const isOnboardingPending = !user?.onboardingCompleted || Boolean(user?.security?.requiredChangePassword);

  return {
    // Only an explicit `false` blocks the admin. If the field is missing the value is
    // `undefined` and everybody keeps working, instead of locking every user out of the panel.
    isRequired: Boolean(isAuthenticated) && mfaConfigured === false && !isOnboardingPending,
    isLoading,
    email: user?.email,
    reloadUser: loadUser,
  };
};

export default useMfaEnrollmentRequired;
